require('../../modules/es.string.iterator');
require('../../modules/es.array.from');

module.exports = require('../../internals/path').Array.from;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/es/array/from.js
// module id = 182
// module chunks = 0